import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {ConfigurationProvider} from "../../configuration/configuration";
import {HttpServiceProvider} from "../../http-service/http-service";
import {OrderStatus} from "../../../model/lib/enums/OrderStatus";
import {Service} from "../../../model/lib/interfaces/Service";
import {Shift} from "../../../model/lib/interfaces/Shift";
import {Order} from "../../../model/lib/interfaces/Order";

@Injectable()
export class OrderService {
  constructor(private configurationService: ConfigurationProvider,
              private httpService: HttpServiceProvider) {
  }

  fetchOrdersByShiftAndDate(service: Service, shift: Shift, dateISOString: string): Observable<Order[]> {
    return this.httpService.get(
      this.configurationService.apiUrl() + `business/order/service/shift/date?id=${service.id}&shiftId=${shift.id}&fromDate=${dateISOString}&status=${OrderStatus.PENDING}`)
      .map(data => <Order[]>data.json());
  }

  fetchVisitorOrdersByShiftAndDate(shift: Shift, dateISOString: string): Observable<Order[]> {
    return this.httpService.get(
      this.configurationService.apiUrl() + `business/order/shift/date/visitor?shiftId=${shift.id}&date=${dateISOString}`)
      .map(data => <Order[]>data.json());
  }

  fetchOrdersByShiftAndDateAndCustomerAccount(service: Service, shift: Shift, dateISOString: string, customerAccountId: number): Observable<Order> {
    return this.httpService.get(
      this.configurationService.apiUrl() + `business/order/service/shift/date/customer/account?id=${service.id}&shiftId=${shift.id}&date=${dateISOString}&customerAccountId=${customerAccountId}`)
      .map((res: any) => {
        if (!res || !res._body || !res.json) {

          return null;
        }
        const data = <Order>res.json();
        return data ? (data as Order) : null;
      });
  }

  updateOrderStatus(order: Order): Observable<Order> {
    return this.httpService.post(this.configurationService.apiUrl() + 'order/save', order)
      .map(data => <Order>data.json());
  }

  saveOrder(order: Order): Observable<Order> {
    return this.httpService.post(this.configurationService.apiUrl() + 'order/save/request', order)
      .map(data => <Order>data.json());
  }

  cancelOrder(order: Order, customerAccountId: number): Observable<void> {
    return this.httpService.post(this.configurationService.apiUrl() + 'business/order/cancel?customerAccountId=' + customerAccountId.toString(), order)
      .map(() => {});
  }

  cancelVisitorOrder(order: Order): Observable<void> {
    return this.httpService.post(this.configurationService.apiUrl() + 'business/order/cancel/visitor', order)
      .map(() => {});
  }

  updateAllOrderStatus(orderIds: number[]): Observable<void> {
    return this.httpService.post(this.configurationService.apiUrl() + 'business/order/update/status/all', orderIds)
      .map(() => {});
  }
}



// WEBPACK FOOTER //
// ./src/providers/gastroflow-services/order-service/order-service.ts